import React from "react";
import { Badge, Button, Card, Col, DatePicker, Input, Row, Select, Space, Typography } from "antd";
import { ClearOutlined, FilterOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;
const { Text } = Typography;

function TransactionScheduleFilters({
    searchRequestNumber,
    setSearchRequestNumber,
    searchPayer,
    setSearchPayer,
    selectedParentDisplayStatus,
    setSelectedParentDisplayStatus,
    selectedCreatedAtRange,
    setSelectedCreatedAtRange,
    totalRows,
}) {
    const activeFilterCount = [
        !!searchRequestNumber,
        !!searchPayer,
        !!selectedParentDisplayStatus,
        !!(selectedCreatedAtRange && selectedCreatedAtRange.length === 2),
    ].filter(Boolean).length;

    return (
        <Card
            bordered={false}
            className="shadow-sm rounded-2xl"
            title={
                <Space>
                    <FilterOutlined />
                    <span>Шүүлтүүр</span>
                    <Badge count={activeFilterCount} />
                </Space>
            }
            extra={<Text type="secondary">Нийт мөр: {totalRows}</Text>}
        >
            <Row gutter={[12, 12]}>
                <Col xs={24} md={6}>
                    <Input
                        placeholder="Хүсэлтийн дугаар"
                        value={searchRequestNumber}
                        onChange={(e) => setSearchRequestNumber(e.target.value)}
                        allowClear
                    />
                </Col>

                <Col xs={24} md={6}>
                    <Input
                        placeholder="Төлөгч / Байгууллага"
                        value={searchPayer}
                        onChange={(e) => setSearchPayer(e.target.value)}
                        allowClear
                    />
                </Col>

                <Col xs={24} md={5}>
                    <Select
                        allowClear
                        placeholder="Ерөнхий төлөв"
                        options={[
                            { label: "Хоосон", value: "EMPTY" },
                            { label: "Нэг", value: "SINGLE" },
                            { label: "Хэсэгчилсэн", value: "PARTIAL" },
                        ]}
                        value={selectedParentDisplayStatus}
                        onChange={setSelectedParentDisplayStatus}
                        style={{ width: "100%" }}
                    />
                </Col>

                <Col xs={24} md={5}>
                    <RangePicker
                        style={{ width: "100%" }}
                        value={selectedCreatedAtRange}
                        onChange={setSelectedCreatedAtRange}
                    />
                </Col>

                <Col xs={24} md={2}>
                    <Button
                        block
                        icon={<ClearOutlined />}
                        onClick={() => {
                            setSearchRequestNumber("");
                            setSearchPayer("");
                            setSelectedParentDisplayStatus(undefined);
                            setSelectedCreatedAtRange([]);
                        }}
                    >
                        Цэвэрлэх
                    </Button>
                </Col>
            </Row>
        </Card>
    );
}

export default TransactionScheduleFilters;